// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"NextGen_TheComp__N8UFy"};